import React, { useEffect, useState } from 'react'
import Breadcrum from '../../components/breadcrum'
import BannerImage from '../../components/BannerImage'
import { Link } from 'react-router-dom'
import { FaPlus, FaSearch } from 'react-icons/fa'
import { useQuery } from '@tanstack/react-query'
import { getAllBlogs } from '../../api/blogApi'
import toast from 'react-hot-toast'
import BlogCard from '../../components/blogCard'

const Blog = () => {
  useEffect(() => {
    document.title = 'Opinion'
  }, [])

  const [searchTerm, setSearchTerm] = useState('')

  const {
    data: blogData = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['blog'],
    queryFn: () => getAllBlogs(),
    onError: (error) => {
      toast.error('Error Fetching opinions')
    },
  })

  const filteredUsers =
    blogData?.filter((blog) => {
      const matchesSearch =
        blog.brandName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        blog.writtenBy?.toLowerCase().includes(searchTerm.toLowerCase())

      let matchesMonth = false
      if (blog.createdAt) {
        const date = new Date(blog.createdAt)
        const monthName = date
          .toLocaleDateString('default', {
            month: 'long',
          })
          .toLowerCase()
        matchesMonth = monthName.includes(searchTerm.toLowerCase())
      }

      return matchesSearch || matchesMonth
    }) || []

  const total = blogData?.length || 0

  if (isLoading) {
    return (
      <>
        <Breadcrum heading="Deal" subheading="Opinion" />
        <div className="text-center py-8">Loading Opinion...</div>
      </>
    )
  }

  if (isError) {
    return (
      <>
        <Breadcrum heading="Deal" subheading="Opinion" />
        <div className="text-center py-8 text-red-500">
          Error loading Opinion. Please try again later.
        </div>
      </>
    )
  }

  return (
    <>
      <Breadcrum heading="Deal" subheading="Opinion" />
      <BannerImage bannerId={1} />

      <div className="bg-gray-100 sm:w-[90%] mx-auto mt-5 rounded-lg shadow-inner">
        <div className="bg-white rounded-md shadow-md p-6 flex justify-center">
          <Link
            to="/dealdashboard/add/blog"
            className="text-xl p-2 rounded-full bg-[#ff7010] text-white"
            title="Add New OPinion"
          >
            <FaPlus />
          </Link>
        </div>
      </div>

      <div className="flex flex-wrap gap-4 justify-between mt-6 mx-auto w-[90%]">
        <div className="fixed right-10 top-[18%] bg-[#ff7010] rounded-full text-white text-xl w-fit h-fit px-2 py-1 shadow-md">
          {total}
        </div>

        {/* Search and Filter Section */}
        <div className="w-full mx-auto my-6">
          <div className="bg-white rounded-xl p-6 shadow-md border border-gray-100">
            <div className="flex flex-col md:flex-row gap-4">
              <div className="flex-1 relative">
                <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                <input
                  type="text"
                  placeholder="Search by company name or writter name or created month"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-12 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#ff7010] focus:border-transparent outline-none transition-all"
                />
              </div>
            </div>
            <div className="mt-4 text-sm text-gray-500">
              Showing {filteredUsers.length} of {blogData.length} Articles
            </div>
          </div>
        </div>

        <BlogCard data={filteredUsers} />
      </div>
      <div className="bg-gray-100 sm:w-[90%] mx-auto mt-5 rounded-lg shadow-inner">
        <div className="bg-white rounded-md shadow-md p-6 flex justify-center">
          <Link
            to="/dealdashboard/add/blog"
            className="text-xl p-2 rounded-full bg-[#ff7010] text-white"
            title="Add New Post"
          >
            <FaPlus />
          </Link>
        </div>
      </div>
    </>
  )
}

export default Blog
